import initialState from "app/initialState";
import { ReducerBase } from "common/reducer";
import Merchant from "domain/merchant";
import { MerchantCustomFieldsLoaded, MerchantFeesLoaded, MerchantPaymentOptionsLoaded, MerchantsLoaded } from "./merchants.actions";
import { Fee } from "domain/fee";
import { CustomField } from "domain/customField";
import PaymentOptionDetails from "domain/paymentOptionDetails";

export default class MerchantsReducer extends ReducerBase<Merchant[]> {

  constructor() {
    super();
    this.addHandler(MerchantsLoaded.EventName, this.handleMerchantsLoaded);
  }

  handleMerchantsLoaded(state: Merchant[] = initialState.allMerchants, event: MerchantsLoaded): Merchant[] {
    return event.merchants;
  }

  handleDefault(state: Merchant[] = initialState.allMerchants): Merchant[] {
    return state;
  }
}


export class MerchantFeesReducer extends ReducerBase<Fee[]> {

  constructor() {
    super();
    this.addHandler(MerchantFeesLoaded.EventName, this.handleMerchantFeesLoaded);
  }

  handleMerchantFeesLoaded(state: Fee[] = initialState.merchantFees, event: MerchantFeesLoaded): Fee[] {
    return event.fees;
  }

  handleDefault(state: Fee[] = initialState.merchantFees) {
    return state;
  }
}

export class MerchantCustomFieldsReducer extends ReducerBase<CustomField[]> {

  constructor() {
    super();
    this.addHandler(MerchantCustomFieldsLoaded.EventName, this.handleMerchantCustomFieldsLoaded);
  }

  handleMerchantCustomFieldsLoaded(state: CustomField[] = initialState.customFields, event: MerchantCustomFieldsLoaded): CustomField[] {
    return event.customFields;
  }

  handleDefault(state: CustomField[] = initialState.customFields) {
    return state;
  }
}

export class MerchantPaymentOptionsReducer extends ReducerBase<PaymentOptionDetails[]> {
  constructor() {
    super();
    this.addHandler(MerchantPaymentOptionsLoaded.EventName, this.handleMerchantPaymentOptionsLoaded);
  }

  handleMerchantPaymentOptionsLoaded(state: PaymentOptionDetails[] = initialState.paymentOptionsDetails, event: MerchantPaymentOptionsLoaded): PaymentOptionDetails[] {
    return event.paymentOptionDetails;
  }

  handleDefault(state: PaymentOptionDetails[] = initialState.paymentOptionsDetails) {
    return state;
  }
}